// extracted by mini-css-extract-plugin
module.exports =  {"productImage":"U9Ncsk","defaultImage":"NqvveY","productBadge":"pOAmTJ"};